import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Route, Redirect } from 'react-router-dom'
import get from 'lodash.get'

import storage from 'storage/index'

import AppNavigation from 'components/AppNavigation'

class AppRoute extends React.Component {
  render() {
    const { loading, user, component: Component, match, ...props } = this.props

    if (!loading && !user) {
      storage.setItem('auth:redirect', window.location.href)

      return <Redirect to="/auth/login" />
    }

    return (
      <React.Fragment>
        {this.props.withNavigation &&
          <AppNavigation />
        }

        <Route
          render={matchProps => (<Component {...matchProps} />)}
          {...props}
        />
      </React.Fragment>
    )
  }
}

const query = graphql(gql`
  query appRoute {
    viewer {
      user {
        _id
      }
    }
  }
  `, {
    options() {
      return {
        fetchPolicy: 'network-only'
      }
    },
    props({ data }) {
      return {
        loading: get(data, 'loading'),
        user: get(data, 'viewer.user')
      }
    }
  }
)

export default compose(
  query
)(AppRoute)



// WEBPACK FOOTER //
// ./src/components/AppRoute/index.js